export default __webpack_public_path__ + "media/zurb/img/icons/zurb-logo-678396674c046de67478d23841fbf5d9.svg";